import PropTypes from 'prop-types';
import { getSrcsetString } from '../../../utils/srcSet';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { Link } from 'dibs-elements/src/Link';

// styles
import styles from './PdpSharedMakerHeadshotModule.scss';

function PdpSharedMakerHeadshotModuleComponent({ seller, renderHeadshot }) {
    const { sellerProfile, sellerPreferences, liveStorefrontProfile } = seller || {};
    const { company: name } = sellerProfile || {};
    const { urlLabel } = sellerPreferences || {};
    const { photos } = liveStorefrontProfile || {};

    const headshot = (photos || []).find(
        photo => photo?.type?.name === 'DEALER_STOREFRONT_HEADSHOT'
    );

    return (
        <div className={styles.wrapper}>
            {/* Headshot */}
            {!!(headshot && headshot.path) && (
                <div className={styles.imageWrap}>
                    {renderHeadshot({
                        alt: name,
                        sizes: '81px',
                        path: headshot.path,
                        imgClass: styles.image,
                        srcSet: getSrcsetString(headshot.path, [81, 162, 243]),
                    })}
                </div>
            )}
            {/* View Profile link */}
            <Link href={`/dealers/${urlLabel}/`} className={styles.name}>
                {name}
            </Link>
        </div>
    );
}

PdpSharedMakerHeadshotModuleComponent.propTypes = {
    seller: PropTypes.object.isRequired,
    renderHeadshot: PropTypes.func.isRequired,
};

PdpSharedMakerHeadshotModuleComponent.defaultProps = {
    //eslint-disable-next-line react/prop-types
    renderHeadshot: ({ path, imgClass, alt, srcSet, sizes }) => (
        <img className={imgClass} sizes={sizes} srcSet={srcSet} src={path} alt={alt} />
    ),
};

export const PdpSharedMakerHeadshotModule = createFragmentContainer(
    PdpSharedMakerHeadshotModuleComponent,
    {
        seller: graphql`
            fragment PdpSharedMakerHeadshotModule_seller on Seller {
                sellerProfile {
                    company
                }
                sellerPreferences {
                    urlLabel
                }
                liveStorefrontProfile {
                    photos {
                        type {
                            name
                        }
                        path
                    }
                }
            }
        `,
    }
);
